import React, {useMemo} from 'react';
import styled from 'styled-components';
import {BubbleWrapper, MessageWrapper} from '../../../global/style';
import Avatar from './Components/Avatar';
import Typing from './Components/Typing';
import Amenities from "./Components/Amenities";

const BotMessageWrapper = styled(MessageWrapper)`
  display: flex;
`;

const MessageContainer = styled.div`
  padding-top: 10px;
  max-width: 80%;

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakSmall}) {
  ;
    padding-top: 12px;
    max-width: 80%
  }

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
    padding-top: 56px;
  }
`;

const Bubble = styled.div`
  background: ${(props) => props.theme.themeColors[props.theme.activeTheme].botChatBubbleBackgroundColor};
  color: ${(props) => props.theme.themeColors[props.theme.activeTheme].botChatBubbleTextColor};
  transition: all ${(props) => props.theme.themeColors[props.theme.activeTheme].transitionSpeed} ease-in-out;
  text-align: left;
  white-space: pre-wrap;
  text-overflow: ellipsis;
  overflow-wrap: break-word;
  display: flow;
  justify-content: center;
  align-items: center;
  font-style: normal;
  font-weight: normal;
  font-family: Lato;
  font-size: 14px;
  line-height: 17px;
  padding: 14px 15px;

  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakSmall}) {
    font-size: 16px;
    line-height: 21px;
    letter-spacing: 0em;
    padding: 14px 25px;
  }

  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakLaptop}) {
    font-size: 24px;
    line-height: 29px;
    padding: 25px 36px 26px 37px;


    ${({typing}) => typing && `padding: 35px 130px;`}
  }
`;

const AvatarPlaceholder = styled.div`
  width: 58px;
  margin-right: 0px;
  margin-top: 4px;

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakSmall}) {
    width: 60px;
    margin-right: 0px;
    margin-top: 2px;
  }

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
    width: 130px;
    margin-top: 16px;
    margin-right: 19px;
  }
`;

function BotText({data, typing, avatar}) {

  const isAmenities = data && data.type === "text" && data.data.includes("᛫");

  let message;

    // Function to convert data to clickable links
    const createLinkMessage = (text) => {
      const linkRegex = /<a href=["'](.*?)["']>(.*?)<\/a>/g;
      const parts = [];
      let lastIndex = 0;
      let match;
  
      while ((match = linkRegex.exec(text)) !== null) {
        parts.push(text.slice(lastIndex, match.index));
        parts.push(<a key={match.index} href={match[1]} target="_blank" rel="noopener noreferrer">{match[2]}</a>);
        lastIndex = linkRegex.lastIndex;
      }
      
      if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex));
      }
  
      return <>{parts}</>;
    };
  
  if (!typing) {
    message = isAmenities
      ? <Amenities amenities={data.data}/>
      : createLinkMessage(data.data);
  }

  const showAvatar = useMemo(() => (data && data.avatar && data.visible) || (typing && avatar()), [JSON.stringify(data)])

  return (
    <>
      <BotMessageWrapper className="BotMessageWrapper">
        {
          showAvatar
            ? <Avatar className="Avatar"/>
            : <AvatarPlaceholder/>
        }
        <MessageContainer className="MessageContainer" typing={typing}>
          <BubbleWrapper className="BubbleWrapper bot-messages">
            <Bubble
              className={`Bubble${isAmenities ? " amenities" : ""}`}
              typing={typing}
            >
              {
                typing
                  ? <Typing/>
                  : message
              }
            </Bubble>
          </BubbleWrapper>
        </MessageContainer>
      </BotMessageWrapper>
    </>
  );
}

export default BotText;
